import React from 'react';
import {Link} from 'react-router-dom';

import {Content, ContentSection} from 'components';
import {Heading} from 'components/ultra';
import Sidebar from 'containers/sidebar';

import {Grid, Q} from './styles';

export function Help() {
  return (
    <>
      <Sidebar />
      <Content>
        <ContentSection footerWidth>
          <Heading element="h1" gradient={true}>
            Help, I need somebody!
          </Heading>
          <Heading>Check out our frequently asked questions</Heading>
        </ContentSection>
        <ContentSection footerWidth>
          <Grid>
            <Q>
              <Heading element="h3">
                I don't use Strava, do you offer support for Garmin, Polar,
                Suunto?
              </Heading>
              <p>
                Currently we only support Strava, we are planning on adding
                Polar next. However, you can set up your Strava account to
                import all the activities from any other provider. That way you
                can still use our service.
              </p>
            </Q>
            <Q>
              <Heading element="h3">
                Can I print mementos for my friends?
              </Heading>
              <p>No, this is not yet possible.</p>
            </Q>
            <Q>
              <Heading element="h3">
                I have an idea for a memento, can you build that for me?
              </Heading>
              <p>
                Please feel free to reach out to us so we can have a look at
                your idea and possibly build that memento for all of our users.
              </p>
            </Q>
            <Q>
              <Heading element="h3">
                I am a sports event organizer and would like to partner with you
                to offer custom mementos to our participants
              </Heading>
              <p>
                Please feel free to reach out to us with your idea so we can
                have a look at it and possibly partner up with you.
              </p>
            </Q>
            <Q>
              <Heading element="h3">
                I don't want to use Spurtli anymore, what happens with my data?
              </Heading>
              <p>
                Once you revoke access in your Strava settings, all your data we
                got from Strava with your permission will be completely deleted.
                You can find more information regarding how we handle personal
                data in our <Link to="/privacy">privacy policy</Link>.
              </p>
            </Q>
          </Grid>
        </ContentSection>
      </Content>
    </>
  );
}
